import api from './client';
import type { Booking } from 'types/booking';

export const bookingsApi = {
  list: async (params?: { org_id?: string; status?: string; limit?: number; offset?: number }): Promise<Booking[]> => {
    const { data } = await api.get('/bookings', { params });
    return data;
  },

  get: async (id: string): Promise<Booking> => {
    const { data } = await api.get(`/bookings/${id}`);
    return data;
  },

  create: async (booking: Omit<Booking, 'id' | 'created_at' | 'status'> & { force?: boolean; internal?: boolean }): Promise<Booking> => {
    const { data } = await api.post('/bookings', booking);
    return data;
  },

  update: async (id: string, updates: Partial<Booking>): Promise<Booking> => {
    const { data } = await api.patch(`/bookings/${id}`, updates);
    return data;
  },

  delete: async (id: string): Promise<void> => {
    await api.delete(`/bookings/${id}`);
  },

  getFullDays: async (month: string, orgId?: string, fast?: boolean, serviceType?: string, durationMinutes?: number): Promise<{ month: string; max_per_day: number; full_days: string[] }> => {
    const { data } = await api.get('/bookings/full-days', { params: { month, org_id: orgId, ...(fast ? { fast: true } : {}), ...(serviceType ? { service_type: serviceType } : {}), ...(durationMinutes ? { duration_minutes: durationMinutes } : {}) } });
    return data;
  },

  getAvailability: async (date: string, serviceType: string, orgId?: string, fast?: boolean, durationMinutes?: number): Promise<{ date: string; service_type: string; unavailable_slots: string[]; estimated_ready_times?: Record<string, string> }> => {
    const { data } = await api.get('/bookings/availability', { params: { date, service_type: serviceType, org_id: orgId, ...(fast ? { fast: true } : {}), ...(durationMinutes ? { duration_minutes: durationMinutes } : {}) } });
    return data;
  },

  lookupClient: async (phone: string, orgId?: string): Promise<{ found: boolean; dossier_id?: string; nom?: string; prenom?: string; email?: string; phone?: string }> => {
    const { data } = await api.get('/bookings/lookup-client', { params: { phone, org_id: orgId } });
    return data;
  },

  lookupVehicle: async (plate: string, orgId?: string): Promise<{ found: boolean; vehicle_id?: string; plate?: string; marque?: string; modele?: string; km?: number; mec?: number; image_url?: string; dossier_id?: string; client_name?: string; client_phone?: string }> => {
    const { data } = await api.get('/bookings/lookup-vehicle', { params: { plate, org_id: orgId } });
    return data;
  },

  searchVehicles: async (query: string, orgId?: string): Promise<{ plate: string; marque: string; modele: string; vehicle_id?: string; dossier_id?: string; client_name?: string; image_url?: string }[]> => {
    const { data } = await api.get('/bookings/search-vehicles', { params: { q: query, org_id: orgId } });
    return data;
  },
};
